const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaDebtorMultiSelectCtrl = function($scope, $routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp).map((item, itemIndex) => {
    return {
      Name: item,
      Id: itemIndex
    }
  });

  vm.refreshData = refreshData;

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData.map((item) => {
        return item.Name;
      }));
    }
  });

  function refreshData(userSearch) {
    if(userSearch) {
      dataService.search({ 
        endpoint: 'Debtors', 
        searchTerm: userSearch, 
        searchType: 'Name', 
        expression: 'contains', 
        includeDeleted: false, 
        selectFields: 'Name, Id',
        limit: 10 })
        .then((data) => {
          vm.searchResults = data;
        })
        .catch(() => {

        });
    }
  }
};

lbaDebtorMultiSelectCtrl.$inject = $inject;

export default lbaDebtorMultiSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaDebtorMultiSelect/lbaDebtorMultiSelectCtrl.js